/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateDictionaryDto
 */
export interface CreateUpdateDictionaryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    shortname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    valueEn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    dictionaryTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    parentId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateDictionaryDto interface.
 */
export function instanceOfCreateUpdateDictionaryDto(value: object): value is CreateUpdateDictionaryDto {
    if (!('dictionaryTypeId' in value) || value['dictionaryTypeId'] === undefined) return false;
    return true;
}

export function CreateUpdateDictionaryDtoFromJSON(json: any): CreateUpdateDictionaryDto {
    return CreateUpdateDictionaryDtoFromJSONTyped(json, false);
}

export function CreateUpdateDictionaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateDictionaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'shortname': json['shortname'] == null ? undefined : json['shortname'],
        'value': json['value'] == null ? undefined : json['value'],
        'valueEn': json['valueEn'] == null ? undefined : json['valueEn'],
        'dictionaryTypeId': json['dictionaryTypeId'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
    };
}

export function CreateUpdateDictionaryDtoToJSON(value?: CreateUpdateDictionaryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'shortname': value['shortname'],
        'value': value['value'],
        'valueEn': value['valueEn'],
        'dictionaryTypeId': value['dictionaryTypeId'],
        'parentId': value['parentId'],
    };
}

